// extracted by mini-css-extract-plugin
export default {"Strip":"MobileAppletsWidget_Strip__dznd1","MobileTeaser":"MobileAppletsWidget_MobileTeaser__BGWTh"};